/**
 * Génère des initiales cohérentes pour un contact, prénom + nom (max 2 lettres).
 * Fallback intelligent si l'un des deux manque.
 * Exemples : (Jean, Dupont) → "JD" | (Jean, "") → "JE" | ("", Dupont) → "DU" | (null, null) → "?"
 */
export function getContactInitials(prenom, nom) {
  const p = (prenom || '').trim();
  const n = (nom || '').trim();
  if (p && n) return (p.charAt(0) + n.charAt(0)).toUpperCase();
  if (p) return p.substring(0, 2).toUpperCase();
  if (n) return n.substring(0, 2).toUpperCase();
  return '?';
}
